import styled from 'styled-components';
import { shade } from 'polished';

export const Container = styled.button`
  background: #439133;
  height: 56px;
  border-radius: 10px;
  border: 0;
  padding: 0 16px;
  color: #f2f2f2;
  width: 100%;
  line-height: 17px;
  font-weight: 500;
  margin-top: 16px;
  transition: background-color 0.2s;

  &:hover {
    background: ${shade(0.2, '#439133')};
  }
`;
